import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UbsBlogComponent } from './components/ubs-blog/ubs-blog.component';
import { NbActionsModule, NbCardModule,NbDatepickerModule,NbListModule, NbMenuModule, NbSpinnerModule, NbTimepickerModule, NbToastrModule } from '@nebular/theme';
//import { UbsBlogArticleComponent } from '@urbannex/blog/src/lib/components/ubs-blog-article/ubs-blog-article.component';
import { UbsBlogArticleComponent } from './components/ubs-blog-article/ubs-blog-article.component';
import { UbsBlogMenuComponent } from './components/ubs-blog-menu/ubs-blog-menu.component';
import { UbsBlogStoreService } from './services/ubs-blog-store.service';
import {UbsBlogService } from './services/ubs-blog.service';
import { BlogRoutingModule} from './app-routing.module';
import { UbsBlogComponentsComponent } from './ubs-blog-components.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfigurationModule, ConfigurationService } from '@urbannex/configuration';
//import { ConfigurationModule } from '@urbannex/configuration';
import { configurationReducer } from '@urbannex/configuration';
import { StoreModule } from '@ngrx/store';
import { UbsBlogSummaryComponent } from './components/ubs-blog-summary/ubs-blog-summary.component';
import { UbsBlogArticleListComponent } from './components/ubs-blog-article-list/ubs-blog-article-list.component';
import { OfbizFormsModule } from '@urbannex/ofbiz-forms';
import { UbsBlogArticleEditComponent } from './components/ubs-blog-article-edit/ubs-blog-article-edit.component';

import { UbsBlogEditComponent } from './components/ubs-blog-edit/ubs-blog-edit.component';
import { UbsBlogWebcontentComponent } from './components/ubs-blog-edit/ubs-blog-webcontent/ubs-blog-webcontent.component';
import { UbsBlogRolesComponent } from './components/ubs-blog-edit/ubs-blog-roles/ubs-blog-roles.component';
import { CKEditorModule } from 'ng2-ckeditor';

/* export const env = {
  production: false,
  apiUrl:'https://localhost:8443/rest',
  defaultLocale:"en-ZA"
};

export function initializeApp2(appInitService: AppInitConfigService) : ()  => Observable<any> {
  return () => appInitService.init(env);
} */

@NgModule({
  declarations: [UbsBlogComponent,UbsBlogArticleComponent,UbsBlogMenuComponent, UbsBlogComponentsComponent, UbsBlogSummaryComponent, UbsBlogArticleListComponent, UbsBlogArticleEditComponent, UbsBlogEditComponent, UbsBlogWebcontentComponent,UbsBlogRolesComponent],
  imports: [
    CommonModule,
    NbCardModule,
    NbListModule,
    NbSpinnerModule,
    BlogRoutingModule,
    ShareButtonsModule,
    ShareIconsModule,
    FontAwesomeModule,
    NbActionsModule,
    NbListModule,
    NbMenuModule,
    OfbizFormsModule,
    CKEditorModule,
    NbToastrModule.forRoot(),
    NbDatepickerModule,
    NbTimepickerModule.forRoot()
  ],
  exports: [
    UbsBlogComponent,
    UbsBlogArticleComponent,
    UbsBlogMenuComponent,
    UbsBlogSummaryComponent,
    BlogRoutingModule,
  ],
  providers:[UbsBlogStoreService,UbsBlogService
    /* ConfigurationService,
    { provide:APP_INITIALIZER,useFactory:initializeApp2,deps:[AppInitConfigService],multi:true },
    { provide: 'configurationService', useClass: ConfigurationService } */
    ],
})
export class UbsBlogModule { 
  public static forRoot():ModuleWithProviders<UbsBlogModule> {
    return {
      ngModule: UbsBlogModule,
      providers: [UbsBlogStoreService,UbsBlogService]
    };
  }
}

/* { provide:APP_INITIALIZER,useFactory:initializeApp2,deps:[AppInitConfigService],multi:true },
{ provide: 'configurationService', useClass: ConfigurationService } */
